import React from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

export default ({ data }) => {
  return (
    <Container fluid>
      <Row>
        <Col sm={12}>
          <h4 className="text-center">{data.title}</h4>
          <p>{data.p2}</p>
          <ul>
            <li>{data.li1}</li>
            <li>{data.li2}</li>
          </ul>
        </Col>
      </Row>
    </Container>
  )
}
